import { createFileRoute, useParams } from '@tanstack/react-router';
import { FrameworkContractDetailView } from '@/pages/contract/framework-contract/framework-contract-detail-view.tsx';

export const Route = createFileRoute('/_auth/rahmenvertrag/$frameworkContractId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { frameworkContractId: frameworkContractIdParam } = useParams({
    from: '/_auth/rahmenvertrag/$frameworkContractId',
  });

  const frameworkContractId = Number(frameworkContractIdParam);
  if (!Number.isFinite(frameworkContractId)) {
    return <div>Ungültige ID: {frameworkContractId}</div>;
  }
  return <FrameworkContractDetailView frameworkContractId={frameworkContractId} />;
}
